import gql from "graphql-tag";
import { technicianDetailsFields } from "../queries/technicianGetMe";

export const UPDATE_TECHNICIAN = gql`mutation updateTechnician($id: ID!, $updateTechnicianInput: UpdateTechnicianInput!) {
   updateTechnician(id: $id, updateTechnicianInput: $updateTechnicianInput)  {
      ${technicianDetailsFields}
   }
}`;
